import React, { useRef, useState } from 'react';
import { connect } from 'react-redux';
import classnames from 'classnames';

import './eventnavigation.scss';
import { setCurrentEvent } from '../redux/actions/event';
import { ChevronDown } from '../../Components/Icons/Icons';

function EventNavigation ({currentEvent, events, ...props}) {

	const [open, setOpen] = useState(false);
	const buttonRef = useRef();
	
	if(!currentEvent) {
		currentEvent = {
			name: 'Please select an event'
		}
	}

	function selectEvent (event) {
		if(currentEvent.name !== event.name) {
			props.dispatch(setCurrentEvent(event.id))
		}
	}

	return (
		<div className={classnames(["event-navigation"], {open: open})}>
			<div
				ref={buttonRef}
				className="main-event"
				onClick={() => setOpen(!open)}
			>
				<div>
					<p>Current Event</p>
					<h4>{currentEvent.name}</h4>
				</div>
				<ChevronDown className="svg-16"/>
			</div>

			<ul
				style={{top: (open && buttonRef.current) ? `${buttonRef.current.offsetHeight}px` : null}}
			>
				{events.map(event =>
					<li
						key={`event-nav_${event.id}`}
						className={classnames({active: event.name === currentEvent.name})}
						onClick={() => selectEvent(event)}
					>
						<div className="title">
							<div className="circle"></div>
							<p>{event.name}</p>
						</div>
					</li>
				)}
			</ul>
		</div>
	)	
}

const mapStateToProps = (state) => ({
	currentEvent: state.event.current,
	events: state.event.list
});

export default connect(mapStateToProps)(EventNavigation);